import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "notes-header" }
const _hoisted_2 = { class: "notes-title" }
const _hoisted_3 = { class: "notes-scroll-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, {
      class: _normalizeClass(["resource-viewer-toolbar notes-list-modal notes-list-header", _ctx.direction])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, {
          class: "modal-toolbar notelist-modal-toolbar",
          mode: "md"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["toolbar-actions", _ctx.direction])
            }, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                class: _normalizeClass(["close-btn", _ctx.direction]),
                style: {"background-color":"transparent!important"}
              }, [
                _createVNode(_component_ion_icon, { icon: _ctx.closeSharp }, null, 8, ["icon"])
              ], 2)
            ], 2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_ion_content, {
      "scroll-y": false,
      class: _normalizeClass(["notes-content", _ctx.direction])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["notes-list-container", _ctx.direction])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_icon, {
              icon: _ctx.pencilOutline,
              class: "notes-header-icon"
            }, null, 8, ["icon"]),
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.notesTitle), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["notes-actions", _ctx.direction])
          }, [
            _createVNode(_component_ion_searchbar, {
              class: _normalizeClass(["notes-search", _ctx.direction]),
              modelValue: _ctx.query,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query) = $event)),
              placeholder: _ctx.searchPlaceholder,
              debounce: 0,
              onIonInput: _ctx.refresh
            }, null, 8, ["class", "modelValue", "placeholder", "onIonInput"]),
            _createElementVNode("div", {
              class: _normalizeClass(["sub-menu-chiplet notes-add-chiplet", _ctx.direction]),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNote && _ctx.addNote(...args))),
              title: "Add note"
            }, [
              _createVNode(_component_ion_icon, {
                class: "chiplet-icon",
                icon: _ctx.addSharp,
                mode: "md"
              }, null, 8, ["icon"])
            ], 2)
          ], 2),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (n) => {
              return (_openBlock(), _createBlock(_component_ion_card, {
                class: "journey-card note-card",
                key: n.id,
                onClick: ($event: any) => (_ctx.openNote(n))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["note-row", _ctx.direction])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["note-left", _ctx.direction])
                    }, [
                      (_ctx.icons[n.note_metadata.lessonIconId])
                        ? (_openBlock(), _createBlock(_component_ion_icon, {
                            key: 0,
                            src: _ctx.icons[n.note_metadata.lessonIconId],
                            class: "note-list-icon"
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createBlock(_component_ion_icon, {
                            key: 1,
                            icon: _ctx.pencilOutline,
                            class: "note-list-icon generic"
                          }, null, 8, ["icon"]))
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["note-content", _ctx.direction])
                    }, [
                      _createElementVNode("h2", {
                        class: _normalizeClass(["note-title", _ctx.direction])
                      }, _toDisplayString(n.note_metadata?.note_title || '(Untitled)'), 3),
                      _createElementVNode("p", {
                        class: _normalizeClass(["note-preview", _ctx.direction])
                      }, _toDisplayString(_ctx.firstLine(n.note_body)), 3),
                      _createElementVNode("p", {
                        class: _normalizeClass(["note-lesson", _ctx.direction])
                      }, _toDisplayString(n.note_metadata.lessonTitle), 3)
                    ], 2),
                    (_ctx.hasAudioResources(n))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["note-audio-icon", _ctx.direction])
                        }, [
                          _createVNode(_component_ion_icon, { icon: _ctx.volumeHigh }, null, 8, ["icon"])
                        ], 2))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["class"])
  ], 64))
}